module.exports = __webpack_public_path__ + "media/images/bulkchange-icon-1214fd098e26985c61ed1542b09eeb41.svg";